import { Typography } from '@sonnen/web-ui';
import styles from './OptionChips.module.css';

type OptionChipsItem = {
  value: string;
  label: string;
};

type OptionChipsProps = {
  items: OptionChipsItem[];
  dataTestId: string;
  ariaLabel?: string;
};

/**
 * OptionChips Component
 * Displays a list of option chips with accessibility support.
 * Each chip is rendered with proper ARIA roles and labels for screen reader compatibility.
 *
 * @param items - Array of items with value and label to display
 * @param dataTestId - Required test identifier for testing
 * @param ariaLabel - Optional aria-label for the container (defaults to 'Selected options')
 */
export const OptionChips = ({
  items,
  dataTestId,
  ariaLabel = 'Selected options',
}: OptionChipsProps) => {
  return (
    <div className={styles.optionChips} data-testid={dataTestId} role="list" aria-label={ariaLabel}>
      {items.map((item) => (
        <div key={item.value} className={styles.chip} role="listitem" aria-label={item.label}>
          <Typography.Label2>{item.label}</Typography.Label2>
        </div>
      ))}
    </div>
  );
};
